import React from 'react'
import { useTranslation } from 'react-i18next'

import dompurify from 'dompurify'

import * as styles from './Meal.module.scss'

import { HotelDetail } from '../../../../apis/fvillage'
import { getPublication } from '../../../../hooks'
import { Button, Flex, FlexBox, Text } from '../../../basics'

type MealProps = {
  meals: HotelDetail[]
}

const translateNamespace = 'components.Meal'

export const Meal: React.FC<MealProps> = ({ meals }) => {
  const { t, i18n } = useTranslation()

  return (
    <div className={styles.mealContainer}>
      <h2>{t(`${translateNamespace}.title`)}</h2>

      <div className={styles.mealContent}>
        {meals.map(({ images, publications }, index) => {
          const publication = getPublication(i18n.language, publications ?? [])
          const viewMoreUrl = publication?.url
          return (
            // eslint-disable-next-line react/no-array-index-key
            <Flex key={index} optionClass={styles.mealContainerRow}>
              <img src={images?.length ? images[0].url : ''} alt="meal" />

              <Flex optionClass={styles.mealDetail}>
                <FlexBox>
                  <Text pcSize={24} spSize={18} weight="bold">
                    {publication?.name}
                  </Text>
                  <div className={styles.rowGap} />
                  <Text pcSize={16} spSize={14}>
                    <div
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{
                        __html: dompurify.sanitize(
                          publication?.description ?? '',
                          {
                            ADD_ATTR: ['target'],
                          }
                        ),
                      }}
                    />
                  </Text>
                </FlexBox>
                {viewMoreUrl && (
                  <FlexBox optionClass={styles.mealDetailButton}>
                    <a
                      href={viewMoreUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button htmlType="button" variant="primary" bold outline>
                        {t(`${translateNamespace}.viewMore`)}
                        <span className={styles.arrowRight} />
                      </Button>
                    </a>
                  </FlexBox>
                )}
              </Flex>
            </Flex>
          )
        })}
      </div>
    </div>
  )
}
